/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SerievideoVideoidLangsId200,
  GetApiV1SerievideoVideoidLangsId401,
  GetApiV1SerievideoVideoidLangsId404,
  GetApiV1SerievideoVideoidLangsId500,
  GetApiV1SerievideoVideoidLangsIdPathParams,
  GetApiV1SerievideoVideoidLangsIdQueryParams,
  GetApiV1SerievideoVideoidLangsIdQueryResponse,
} from "../../types/serieVideoIdiomasController/GetApiV1SerievideoVideoidLangsId.ts";
import { serieVideoLangViewModelSchema } from "../serieVideoLangViewModelSchema.ts";

export const getApiV1SerievideoVideoidLangsIdPathParamsSchema = z.object({
  videoId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1SerievideoVideoidLangsIdPathParams>;

export const getApiV1SerievideoVideoidLangsIdQueryParamsSchema = z
  .object({
    serieId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1SerievideoVideoidLangsIdQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SerievideoVideoidLangsId200Schema = z.lazy(
  () => serieVideoLangViewModelSchema,
) as unknown as ToZod<GetApiV1SerievideoVideoidLangsId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SerievideoVideoidLangsId401Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoVideoidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SerievideoVideoidLangsId404Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoVideoidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SerievideoVideoidLangsId500Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoVideoidLangsId500>;

export const getApiV1SerievideoVideoidLangsIdQueryResponseSchema = z.lazy(
  () => getApiV1SerievideoVideoidLangsId200Schema,
) as unknown as ToZod<GetApiV1SerievideoVideoidLangsIdQueryResponse>;
